import { withSuspense } from '@lib/common/hoc';
import { lazy } from 'react';

const AddC3Relation = withSuspense(lazy(() => import('./add-c3')));
export default AddC3Relation;

export { C3AddForm } from './c3-add-form';
export { C3PersonSelector } from './c3-person-selector';